// extracted by mini-css-extract-plugin
module.exports = {"head":"EditEmployeeAttendance__head--2e6Lm","hide":"EditEmployeeAttendance__hide--1UxkH"};